<template>
    <!-- <div style="position: fixed; bottom: 0%; top: 0%; left: 0; right: 0;"> -->
        <!-- <div style="overflow-y: scroll; height: 100%;"> -->
        <div class="knd-chat-user" :class="content.className">
            <div class="chat knd-bg-jade-light">
                <div class="chat-header knd-bg-green-light knd-py-5">
                    <div class="knd-flex knd-justify-between knd-items-center knd-wrapper__xl knd-m-auto">
                        <div class="chat-header__icon">
                            <img class="chat-header__image" :src="'https://pointer-dev.kro-ncrv.nl/' + $store.state.match.avatar" />
                        </div>
                        <div class="chat-header__name">{{$store.state.match.name}}</div>
                        <div class="chat-header__credits" :class="{'no-credits': credits === 0}">{{credits}} credits</div>
                    </div>
                </div>
    
                <ChatContainer :content="content" :simulate="simulate" />
    
                <div class="chat-footer knd-bg-red knd-py-5"  v-if="credits === 0">
                    <div class="knd-max-w-3xl knd-m-auto knd-text-white">
                        Uw saldo is ontoereikend. Waardeer uw credits op voordat u weer een bericht kunt sturen.
                    </div>
                </div>
            </div>
        </div>
    </template>
    
    <script>
        import ChatContainer from './chat-container.vue';
    
        export default {
            components:{ChatContainer},
            props: {
                content: {
                    type: Object
                },
                simulate: {
                    type: Boolean,
                    default: true
                }
            },
            mounted () {
                debugger;
            },
            computed: {
                credits() {
                    return this.$store.state.credits;
                }
            }, 
            methods: {},
        }
    </script>
    
    <style lang="scss">

    </style>